import { createSelector } from '@reduxjs/toolkit'
import { getPoliciesUnexpelled } from './policies'
import showValueMeter from '../../utils/show_value_meter'

export const getValueMeterPolicies = createSelector(
  getPoliciesUnexpelled,
  (policies = []) =>
    policies
      .filter((policy) => showValueMeter(policy))
)
